import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useEffect, useRef } from 'react';
import { useLoadWidget, propsBoolean, propsObject } from '../utils';
import { SgwtWidgetContext } from '../context';
const name = 'sgwt-mini-footer';
export const SgwtMiniFooter = ({ about, accessibilityCompliance, accessibilityLink, accessibilityUid, contactUs, contactUsByHelpCenter, container, cookiesConsent, design, i18n, legalNotices, logoLink, logoLinkTitle, mode, noBorder, type, onAboutLinkClicked, onAccessibilityLinkClicked, onUserConsent, onUserConsentChanged, id, onWidgetReady, }) => {
    const ref = useRef();
    const { infrastructure } = useContext(SgwtWidgetContext);
    useLoadWidget(name, infrastructure);
    useEffect(() => {
        if (!!ref.current) {
            onWidgetReady?.(ref.current);
        }
    }, [ref, onWidgetReady]);
    // [EVENTS] ---- Clikcs ----
    useEffect(() => {
        const eventName = `${name}--about-link-clicked`;
        const linkClicked = () => onAboutLinkClicked?.();
        document.addEventListener(eventName, linkClicked);
        return () => document.removeEventListener(eventName, linkClicked);
    }, [onAboutLinkClicked]);
    useEffect(() => {
        const eventName = `${name}--accessibility-link-clicked`;
        const linkClicked = () => onAccessibilityLinkClicked?.();
        document.addEventListener(eventName, linkClicked);
        return () => document.removeEventListener(eventName, linkClicked);
    }, [onAccessibilityLinkClicked]);
    // [EVENTS] ---- User Consent ----
    useEffect(() => {
        const eventName = `${name}--current-user-consent`;
        const userConsent = (event) => onUserConsent?.(event.detail);
        document.addEventListener(eventName, userConsent);
        return () => document.removeEventListener(eventName, userConsent);
    }, [onUserConsent]);
    useEffect(() => {
        const eventName = `${name}--user-consent-changed`;
        const consentChanged = (event) => onUserConsentChanged?.(event.detail);
        document.addEventListener(eventName, consentChanged);
        return () => document.removeEventListener(eventName, consentChanged);
    }, [onUserConsentChanged]);
    return (_jsx("sgwt-mini-footer", { ref: ref, id: id, about: propsObject(about), "accessibility-compliance": accessibilityCompliance, "accessibility-link": accessibilityLink, "accessibility-uid": accessibilityUid, "contact-us": propsObject(contactUs), "contact-us-by-help-center": contactUsByHelpCenter, container: container, "cookies-consent": propsBoolean(cookiesConsent), design: design, i18n: propsObject(i18n), "legal-notices": propsObject(legalNotices), "logo-link": logoLink, "logo-link-title": logoLinkTitle, mode: mode, "no-border": propsBoolean(noBorder), type: type }));
};
//# sourceMappingURL=SgwtMiniFooter.js.map